const styles = {
  button: {
    margin: 5,
    color: 'white',
  },
};

export default styles;
